import { forwardRef, HTMLAttributes, PropsWithChildren, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'types'
import Styles from './Container.module.scss'
import cx from 'classnames'
import { observer } from 'mobx-react-lite'

export const Container = observer(
  forwardRef<HTMLDivElement, PropsWithChildren<HTMLAttributes<HTMLDivElement>>>(
    ({ children, className, ...rest }, fRef) => {
      const leftSidebarLocked = useSelector((state: RootState) => state.sidebar.locked)
      const [sidebarLocked, setSidebarLocked] = useState(leftSidebarLocked)

      useEffect(() => {
        // We need to wait until the animation is over and the left sidebar is closed before the class is applied
        setTimeout(() => {
          setSidebarLocked(leftSidebarLocked)
        }, 0)
      }, [leftSidebarLocked])

      return (
        <div className={cx(Styles.root, className, { [Styles.collapsed]: sidebarLocked })} {...rest} ref={fRef}>
          {children}
        </div>
      )
    },
  ),
)
